import React, {FC} from 'react';

import {Text, Colors} from '@optimaxdev/design-system';

import classNames from 'classnames';

import {useGetRegions} from 'hooks/location/location';

import {getVisiblyErrorContent} from './helpers';

import s from './visiblyExamFail.scss';

type PropsType = {
    handleBack: () => void;
    errorMessage: string;
    selectedState: string;
};

/**
 * TYP screen when visibly exam fails
 */
export const VisiblyExamFail: FC<PropsType> = ({errorMessage, handleBack, selectedState}) => {
    const regions = useGetRegions('US')?.regions?.US;

    const regionName = regions?.find(region => region.value === selectedState);

    const content = getVisiblyErrorContent(regionName?.label || '')[errorMessage];
    const isDesktop = __BUILD_TYPE__ === 'desktop';

    if (!errorMessage) return null;

    return (
        <>
            <div className={s.container}>
                <div>
                    {content?.map(({text, title}, count) => (
                        <React.Fragment key={title}>
                            <Text
                                as="p"
                                color={Colors.limedSpruce}
                                lineHeight="24px"
                                margin="0 0 10px"
                                size="16px"
                                bold
                            >
                                {title}
                            </Text>
                            <Text as="p" color={Colors.limedSpruce} lineHeight="24px" size="16px">
                                {text}
                            </Text>
                            {count !== content.length - 1 && <div className={s.horizontalLine} />}
                        </React.Fragment>
                    ))}
                </div>
                <button
                    className={classNames(s.btn, {[s.desktop]: isDesktop})}
                    onClick={handleBack}
                    type="button"
                >
                    <Text color={Colors.nevada} lineHeight="150%" size="14px" underline>
                        Go back to choose another confirmation method
                    </Text>
                </button>
            </div>
        </>
    );
};
